import { createFileRoute } from '@tanstack/react-router';
import { GuestGate } from '@/features/account/shell/GuestGate';
import OpportunitiesListPage from '@/features/home/opportunities-list';
import { opportunitiesSearchSchema } from '@/features/home/opportunities-list/opportunities-search.schema';

export const Route = createFileRoute('/oportunidades/')({
  validateSearch: opportunitiesSearchSchema,
  component: () => (
    <GuestGate>
      <OpportunitiesListPage />
    </GuestGate>
  ),
});
